import { useContext } from 'react';
import { BeefCoProjectContext } from "../context";
export var useBeefCoProject = function useBeefCoProject() {
  var project = useContext(BeefCoProjectContext);
  if (!project) throw new Error('Unable to call useBeefCoProject before config initialization');
  return project;
};